import React from 'react';
import SignerDocument from 'signer-app/signer-signature-document/document';
import { Box } from '@dropbox/dig-foundations';
import { PropsOf } from 'signer-app/utils/props-of';

export function SignerPreviewDocument(props: PropsOf<typeof Box>) {
  return (
    <Box overflowY="scroll" {...props}>
      <SignerDocument />
    </Box>
  );
}
